module.exports = "<div class=\"synPane\" id=\"synWizardPane\" data-scrollable=\"false\"></div>";